/** Set to true when real names are ready to show (demo cite + testimonial author). */
export const showPlaceholderNames = false;

export const navLinks = [
  { id: "features", label: "Features" },
  { id: "patient-app", label: "Patient App" },
  { id: "use-cases", label: "Use Cases" },
  { id: "pricing", label: "Pricing" },
  { id: "about", label: "About" },
  { id: "resources", label: "Resources" },
];

export const proofStats = [
  { value: "200+", label: "Clinics onboarded" },
  { value: "50,000+", label: "Patients served" },
  { value: "99.9%", label: "Uptime" },
  { value: "RM 200", label: "Per month, all-in" },
];

export const featurePillars = [
  {
    title: "Run your clinic",
    text: "Queue management, electronic medical records, billing, pharmacy dispensing, and real-time analytics in one system.",
  },
  {
    title: "Engage your patients",
    text: "Every patient gets their own health app with records, results, and reminders on iOS and Android.",
  },
  {
    title: "Grow your practice",
    text: "Multi-branch support, panel management, LHDN e-Invoice, and analytics to scale confidently.",
  },
];

export const useCases = [
  {
    num: "01",
    title: "The patient journey",
    text: "From first visit to follow-up, the patient stays connected every step.",
    outcome: "Higher return rate · Fewer no-shows · Stronger loyalty",
    steps: [
      "Patient scans QR code and queue is assigned",
      "Doctor opens full history and prescribes",
      "Invoice generated and e-Invoice submitted",
      "Patient accesses records in XsBenefits app",
      "Automated reminder drives follow-up visit",
    ],
  },
  {
    num: "02",
    title: "Running a busy clinic",
    text: "Less admin and faster workflows for high patient volumes.",
    outcome: "More patients per day · Fewer errors · Faster closing",
    steps: [
      "Walk-ins and appointments in one queue",
      "EMR opens with complete patient history",
      "Pharmacy receives prescription instantly",
      "Invoice generated after dispensing",
      "Revenue report ready same day",
    ],
  },
  {
    num: "03",
    title: "Growing your practice",
    text: "One platform for multiple branches with shared records and analytics.",
    outcome: "Seamless multi-branch · Better decisions · Scalable",
    steps: [
      "Single dashboard for all branches",
      "Shared records across locations",
      "Branch performance comparison analytics",
      "Centralized corporate panel billing",
      "KiraOS add-on for consolidated reporting",
    ],
  },
];

export const pricingFeatures = [
  "Smart queue management",
  "Electronic medical records (EMR)",
  "Billing + LHDN e-Invoice included",
  "Pharmacy & dispensing with inventory",
  "Analytics & reporting",
  "Multi-branch support",
  "Patient health app",
  "WhatsApp integration for reminders",
  "Migration assistance",
];

export const pricingCompare = [
  ["Patient health app", "Included", "Not available"],
  ["LHDN e-Invoice", "Included", "Extra fee"],
  ["Queue management", "Included", "Often separate module"],
  ["Analytics & reporting", "Included", "Premium tier only"],
  ["Multi-branch support", "Included", "Add-on per branch"],
  ["Price", "RM 200 / month", "Varies, often higher"],
];

export const resources = [
  {
    cat: "LHDN & Compliance",
    title: "LHDN e-Invoice for clinics: what you need to know in 2026",
    text: "Malaysia's e-invoicing mandate is here. Here's what it means for your clinic, what you need to do, and how byond care handles it automatically.",
  },
  {
    cat: "Malaysia healthcare",
    title: "Malaysia's healthcare digitalisation in 2026: what it means for your clinic",
    text: "Malaysia has marked 2026 as the year for major health reforms. A practical breakdown of what's changing and how clinic operators should prepare.",
  },
  {
    cat: "Patient engagement",
    title: "How to reduce no-shows at your clinic (without calling every patient)",
    text: "No-shows cost Malaysian clinics hours of lost revenue every week. The most effective ways to reduce them including automated reminders that actually work.",
  },
  {
    cat: "Clinic management",
    title: "Is it time to switch your clinic management system? A practical guide",
    text: "If your current system is slowing you down, here's how to evaluate whether it's time to switch and what to look for in a replacement.",
  },
];

export const testimonials = [
  {
    id: 1,
    text: "Switching to byond care cut our front desk time in half. The queue system alone was worth it, and our patients now check results in the app instead of calling.",
    author: "Dr. [Name] — GP Clinic, Kuala Lumpur",
  },
];
